var styleDataHash = '5be4690c';  
export const injectCss = (() => {
  var css = `.loelJ,.loelJ:visited{background:var(--ricos-custom-mention-background-color,transparent)!important;border-radius:2px;color:var(--ricos-custom-mention-color,var(--ricos-action-color,#116dff));display:inline-block;padding-left:2px;padding-right:2px;text-decoration:none}.jrknM,.jrknM:visited{padding-left:4px;padding-right:4px}.loelJ:focus,.loelJ:hover{outline:0;text-decoration:underline}.loelJ:active,.loelJ:focus,.loelJ:hover{color:var(--ricos-custom-mention-color,var(--ricos-action-color,#116dff))}.I5U3R{cursor:default}.ww7eN{cursor:pointer}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





